import { useBack } from '@/ui/back/backStack';
import { useI18n } from '@/ui/i18n/I18nProvider';
import styles from './ExitConfirm.module.css';

/** S24 on the last Back step of the native app (ux-screens §6.2 step 14). Back again = stay. */
export function ExitConfirm({ onStay, onLeave }: { onStay: () => void; onLeave: () => void }) {
  const { t } = useI18n();
  useBack(onStay);
  return (
    <div className={styles.scrim}>
      <div
        className={styles.sheet}
        role="alertdialog"
        aria-labelledby="exit-title"
        aria-describedby="exit-body"
      >
        <h2 id="exit-title" className={styles.title}>
          {t('ui.exit.title')}
        </h2>
        <p id="exit-body" className={styles.body}>
          {t('ui.exit.body')}
        </p>
        <div className={styles.actions}>
          <button type="button" className={styles.secondary} onClick={onLeave}>
            {t('ui.exit.leave')}
          </button>
          {/* eslint-disable-next-line jsx-a11y/no-autofocus -- the safe choice gets focus */}
          <button type="button" className={styles.primary} onClick={onStay} autoFocus>
            {t('ui.exit.stay')}
          </button>
        </div>
      </div>
    </div>
  );
}
